import React, { useState } from 'react';
import { message } from 'antd';
import { useNavigate } from 'react-router';
import { usePostHog } from '@posthog/react';
import { authActions } from '../../actions/auth';
import './AuthScreen.css';

function ForgotPasswordScreen() {
  const navigate = useNavigate();
  const posthog = usePostHog();
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      await authActions.forgotPassword(email);

      // PostHog: Capture password reset request
      posthog?.capture('password_reset_requested');

      message.success('If the email exists, an OTP has been sent');
      navigate('/reset-password', { state: { email } });
    } catch (err) {
      posthog?.capture('password_reset_request_failed', {
        error_status: err?.response?.status,
      });
      const errorMessage =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        (err?.response?.status === 404 ? 'Email address not found.' : null) ||
        (err?.response?.status === 429 ? 'Too many attempts. Please wait a few minutes.' : null) ||
        err?.message ||
        'Something went wrong. Please try again.';
      message.error(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="auth-container">
      {[...Array(6)].map((_, i) => (
        <span key={i} className="bubble" />
      ))}
      <div className="auth-card">
        <div className="logo-container">
          <img src="/uro_logo_white.png" alt="URO" className="logo" />
        </div>
        <h2>Forgot Password</h2>
        <form className="auth-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="forgotEmail">Email</label>
            <input
              id="forgotEmail"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <button
            className="button"
            type="submit"
            disabled={isSubmitting}
            style={{ opacity: isSubmitting ? 0.65 : 1, cursor: isSubmitting ? 'not-allowed' : 'pointer' }}
          >
            {isSubmitting ? 'Sending…' : 'Send OTP'}
          </button>
          <button
            type="button"
            className="link-button"
            onClick={() => navigate('/login')}
          >
            Back to login
          </button>
        </form>
      </div>
    </div>
  );
}

export default ForgotPasswordScreen;
